import React from 'react';

import {MARK_SELECTION_HINT} from '../constants';

interface AnnotationModeKeyboardHintProps {
  /** The id the toggle's `aria-describedby` points at. */
  id: string;
}

/**
 * The keyboard instructions an annotation-mode toggle describes itself with, so a
 * student can find out how to mark text without a mouse at any time, not only while
 * the coachmark shows (SC 3.3.2).
 */
export default function AnnotationModeKeyboardHint({id}: AnnotationModeKeyboardHintProps) {
  return (
    <span id={id} className='sr-only'>
      {MARK_SELECTION_HINT}
    </span>
  );
}
